import React from 'react'
import { connect } from 'react-redux'
import {
  setDiscoveryAreaOpenState,
} from 'Modules/searchPage/actions'
import { calculateLcaAndSelectedAreas, setHoveredDiscoveryArea, selectAllChildrenArea } from 'Modules/searchMap/actions'
import { selectUserCurrentArea } from 'Modules/user/defaults/selectors'
// import { updateSelectedFiltersList } from 'Modules/filters/actions'
// import DiscoveryArea from './DiscoveryArea'
import Loadable from 'Components/LoadableToImported'

const loading = () => (
  <div style={{ minHeight: '130px' }} />
)

// replace webpackChunkName to webpackChunkName to see chunk name
export const DiscoveryArea = Loadable({
  loader: () => import(/* webpackChunkName: "DiscoveryArea" */ './DiscoveryArea'),
  loading,
  chunkName: 'DiscoveryArea',
})

const mapStateToProps = state => ({
  lcaMapTree: state.searchMap.lcaMapTree,
  commonParent: state.searchMap.commonParent,
  lookups: state.lookups,
  isDiscoveryAreaOpen: state.searchPage.isDiscoveryAreaOpen,
  userCurrentCity: selectUserCurrentArea(state),
  lastSearchObj: state.location.searchAreaParamObj,
  filterByViewPort: state.location.lastSearchObj.filterByViewPort,
  // lastSearch: getLocationSearch(state),
})
const actions = {
  setDiscoveryAreaOpenState,
  calculateLcaAndSelectedAreas,
  setHoveredDiscoveryArea,
  selectAllChildrenArea,
  // updateSelectedFiltersList,
}

export default connect(mapStateToProps, actions)(DiscoveryArea)
